import HomeMicroShapesConfig from 'app/views/home/webgl/particles/config/HomeMicroShapesConfig';
import HomeMicroShape from 'app/views/home/webgl/particles/scenes/HomeMicroShape';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import { particles } from 'app/contracts/Particles';
import HomeColours from 'app/views/home/config/HomeColours';
import ComboCounter from 'utils/ComboCounter';

export default class HomeMicroShapeController {
	//Shared scene-state bag (ScreensDepartment passes its own reference) — read
	//for the virtual-canvas ratio (ex globals.virtualWidth/virtualHeight):
	private _sceneProps: particles.SceneProps;

	private shapes: Array<HomeMicroShape> = [];
	private active: boolean = true;
	private _counters: ComboCounter = new ComboCounter();

	constructor(sceneProps: particles.SceneProps) {
		this._sceneProps = sceneProps;
	}


	private shapeConfig = [
		HomeMicroShapesConfig.lineH,
		HomeMicroShapesConfig.lineV,
		HomeMicroShapesConfig.square,
		HomeMicroShapesConfig.x,
		HomeMicroShapesConfig.arrowUp,
		HomeMicroShapesConfig.plus
	];

	private cycleInt;

	public phaseIn(interval: number, randomSeed: number = 0) {
		for (var i = 0; i < this.shapes.length - 1; i++) {
			let target = this.shapes[i];
			this._counters.add(
				() => {
					target.fadeIn();
				},
				interval + Math.random() * randomSeed
			);
		}
	}

	public juggleSingleBlocks() {
	}

	public orbit(randomSeed = 0) {
		if (this.cycleInt) {
			clearInterval(this.cycleInt);
		}

		let shapeConfig = HomeMicroShapesConfig.x;

		for (var i = 0; i < this.shapes.length - 1; i++) {
			let target = this.shapes[i];
			this._counters.add(() => {
				target.orbit(i, shapeConfig);
			}, 0);
		}
	}

	public create(particlePool: Array<HomeParticle>, fromIndex: number = 0, type: string, config: any): number {
		let particlePoolIndex: number = fromIndex;
		let createShapeRows = config.createShapeRows;
		let blockW = 3;
		let blockH = 3;
		let maxBlockCols = config.maxBlockCols;
		let gridSize = config.gridSize;
		let startX = config.startX;
		let scale = config.scale;
		let x = config.startX;
		let y = config.startY;

		this._counters.clear();

		for (var i = 1; i <= createShapeRows; i++) {
			for (let j = 0; j < maxBlockCols; j++) {
				if (Math.random() < 0.8) {
					let shape = new HomeMicroShape(this.randomShape(), this._sceneProps);
					particlePoolIndex = shape.assignPool(particlePool, particlePoolIndex) + 1;
					shape.init();
					shape.setShapeSize(x, y, gridSize, scale);
					shape.setColour(this.randomColour());
					this.shapes.push(shape);
				}

				x += blockW * gridSize;
			}

			x = startX;
			//Ex globals.virtualWidth / globals.virtualHeight — same metrics off
			//sceneProps.sizes (container.w/h = virtual width/height):
			y += blockH * (gridSize * (this._sceneProps.sizes.container.w / this._sceneProps.sizes.container.h)) * 1.2;
		}

		return particlePoolIndex;
	}

	public tick() {
		if (!this.active) {
			return;
		}

		this._counters.tick();

		for (var i = 0; i < this.shapes.length - 1; i++) {
			this.shapes[i].tick();
		}
	}

	public reset() {
		this._counters.clear();

		for (var i = 0; i < this.shapes.length - 1; i++) {
			this.shapes[i].reset();
		}
	}

	private randomColour() {

		return HomeColours.getRandomColour(HomeColours.dynamicSets.tt);
	}

	private randomShape() {
		return this.shapeConfig[Math.floor(Math.random() * (this.shapeConfig.length - 0.01))];
	}

}
